/* Free Engraving · October 2026.
   1) The count: when it scrolls into view the gone marks burn out and the number drops to today's.
   2) The landing buy module: the size tiles switch the product in one form, and the receipt follows. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var n = Math.abs(Math.round(cents));
    return '$' + Math.floor(n / 100).toLocaleString('en-US') + '.' + String(n % 100).padStart(2, '0');
  }

  /* ---------- 1) The count ---------- */
  function animateCount(el) {
    if (el.dataset.feRun) return;
    el.dataset.feRun = '1';
    var n = el.querySelector('.fe-tally__n');
    if (!n) return;
    var from = Number(n.getAttribute('data-from'));
    var to = Number(n.getAttribute('data-to'));
    if (reduced || !(from > to)) {
      el.classList.remove('is-anim');
      return;
    }
    function run() {
      var step = 34;
      var dur = (from - to) * step + 260;
      var t0 = null;
      el.classList.add('is-run');
      function tick(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0 - 180) / dur);
        if (k > 0) n.textContent = Math.round(from - (from - to) * (1 - Math.pow(1 - k, 2)));
        if (k < 1) requestAnimationFrame(tick);
        else n.textContent = to;
      }
      requestAnimationFrame(tick);
    }
    n.textContent = from;
    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        io.disconnect();
        run();
      }
    }, { threshold: 0.6 });
    io.observe(el);
  }

  /* ---------- 2) The landing buy module ---------- */
  function initBuy(root) {
    if (root.dataset.feInit) return;
    root.dataset.feInit = '1';

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var variantInput = form && form.querySelector('input[name="id"]');
    var formComponent = root.querySelector('product-form-component');
    var tiles = root.querySelectorAll('[data-fe-size]');
    var photos = root.querySelectorAll('[data-fe-photo]');
    var receipt = root.querySelector('[data-fe-receipt]');
    var configurator = root.querySelector('engraving-configurator');
    var unit = Number(root.dataset.feUnit) || 2500;
    var free = root.dataset.feFree === 'true';

    function current() {
      var on = root.querySelector('[data-fe-size] input:checked');
      return on ? on.closest('[data-fe-size]') : tiles[0];
    }

    function quantity() {
      var q = form && form.querySelector('input[name="quantity"]');
      return Math.max(1, Number(q && q.value) || 1);
    }

    function engraving() {
      if (!configurator) return { units: 0, label: '' };
      var text = configurator.querySelector('[data-toggle="text"]');
      var logo = configurator.querySelector('[data-toggle="logo"]');
      var t = !!(text && text.checked);
      var l = !!(logo && logo.checked);
      return { units: Number(t) + Number(l), label: t && l ? 'text + logo' : l ? 'logo' : t ? 'text' : '' };
    }

    function paintReceipt() {
      if (!receipt) return;
      var tile = current();
      if (!tile) return;
      var q = quantity();
      var price = Number(tile.dataset.fePrice) || 0;
      var title = tile.dataset.feTitle || '';
      var eng = engraving();
      var compare = eng.units * unit * q;
      var charge = free ? 0 : compare;
      var total = price * q + charge;
      var engCell;
      if (!eng.units) engCell = '<dd><span class="fe-rc__muted">Add it above</span></dd>';
      else if (free) engCell = '<dd><s>' + money(compare) + '</s><b class="fe-rc__free">Free</b></dd>';
      else engCell = '<dd><b>' + money(charge) + '</b></dd>';
      receipt.innerHTML =
        '<div><dt>' + title + (q > 1 ? ' × ' + q : '') + '</dt><dd>' + money(price * q) + '</dd></div>' +
        '<div><dt>Engraving' + (eng.label ? ', ' + eng.label : '') + (q > 1 && eng.units ? ' × ' + q : '') + '</dt>' + engCell + '</div>' +
        '<div><dt>Shipping, continental US</dt><dd><b>Free</b></dd></div>' +
        '<div class="fe-rc__total"><dt>Total</dt><dd>' + money(total) + '</dd></div>';
    }

    function select(tile) {
      tiles.forEach(function (t) { t.classList.toggle('is-on', t === tile); });
      if (variantInput) variantInput.value = tile.dataset.feVariant || '';
      if (formComponent) {
        formComponent.dataset.productId = tile.dataset.feProduct || '';
        formComponent.dataset.productUrl = tile.dataset.feUrl || '';
      }
      photos.forEach(function (p) { p.hidden = p.dataset.fePhoto !== tile.dataset.feSize; });
      var atc = root.querySelector('add-to-cart-component');
      if (atc && tile.dataset.feMedia) atc.setAttribute('data-product-variant-media', tile.dataset.feMedia);
      paintReceipt();
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.name === 'fe-size') {
        var tile = t.closest('[data-fe-size]');
        if (tile) select(tile);
        return;
      }
      if (t.matches('[data-toggle]') || t.name === 'quantity') setTimeout(paintReceipt, 0);
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t instanceof HTMLInputElement && t.name === 'quantity') paintReceipt();
    });
    document.addEventListener('quantity-selector:update', function () { paintReceipt(); });

    var first = current();
    if (first) select(first);
  }

  function init() {
    document.querySelectorAll('.fe-tally.is-anim').forEach(animateCount);
    document.querySelectorAll('[data-fe-buy]').forEach(initBuy);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
